import { useCallback, useEffect, useRef, useState } from 'react';
const DELAY_HIDE = 100;
const DELAY_SHOW = 500;
export const useDelayedDisclosure = () => {
    const [active, setActive] = useState(false);
    const hideTimer = useRef();
    const showTimer = useRef();
    useEffect(() => () => clearTimeout(hideTimer.current), []);
    useEffect(() => () => clearTimeout(showTimer.current), []);
    const open = useCallback(() => {
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        showTimer.current = window.setTimeout(() => setActive(true), DELAY_SHOW);
    }, []);
    const close = useCallback(() => {
        clearTimeout(hideTimer.current);
        clearTimeout(showTimer.current);
        hideTimer.current = window.setTimeout(() => setActive(false), DELAY_HIDE);
    }, []);
    return [active, { open, close }];
};
//# sourceMappingURL=useDelayedDisclosure.js.map